import { Link } from "react-router-dom";

import { TinsmithLockup } from "@tinsmith/brand";

import styles from "./TinsmithLogo.module.css";

export type TinsmithLogoProps = {
  readonly href: string;
};

export const TinsmithLogo = ({ href }: TinsmithLogoProps) => (
  <Link aria-label="Tinsmith home" className={styles.logo} to={href}>
    <TinsmithLockup size={24} wordmarkClassName={styles.word} />
  </Link>
);
